import { Identifier } from "react-admin";

import { Space } from "types";

import * as Const from "../../consts";
import { getUser } from "../getUser";

const SUFFIX = "v1";

export const setPersistedSpaces = async (
  spaces: Space[],
  userId?: Identifier,
  orgId?: Identifier
) => {
  let uId = userId;
  let oId = orgId;

  if (!uId || !oId) {
    const user = await getUser();

    uId = user.id;
    oId = user.app_metadata.profile?.space_id;
  }

  localStorage.setItem(`${uId}_${oId}${SUFFIX}`, JSON.stringify(spaces));
};

export const getPersistedSpaces = async (userId?: Identifier, orgId?: Identifier) => {
  let uId = userId;
  let oId = orgId;

  if (!uId || !oId) {
    const user = await getUser();

    uId = user.id;
    oId = user.user_metadata.space_id;
  }

  const cachedSpaces = localStorage.getItem(`${uId}_${oId}${SUFFIX}`);

  if (!cachedSpaces) {
    return Const.WORKSPACE_SELECTION_SELECT_ALL;
  }

  return JSON.parse(cachedSpaces) as Space[];
};
